import { useEffect } from 'react';

// Registry with timestamps so effects run once per page entry, but not twice in Strict Mode
const lastRunAtByKey = new Map();

/**
 * Ensures the callback runs at most once within a short window (cooldown) for a given key.
 * This avoids React 18 StrictMode double-invoke on mount, but still re-runs when
 * the user navigates away and returns later.
 *
 * @param {string} key Unique key for the operation (e.g., endpoint path or route id)
 * @param {() => void | (() => void)} callback The function to run
 * @param {any[]} deps Dependency array controlling when to attempt execution
 * @param {number} cooldownMs Minimum milliseconds between executions for this key (default 1500)
 */
export default function useCallOnce(key, callback, deps = [], cooldownMs = 1500) {
  useEffect(() => {
    const now = Date.now();
    const last = lastRunAtByKey.get(key) || 0;
    if (now - last < cooldownMs) return undefined;
    lastRunAtByKey.set(key, now);
    const cleanup = callback?.();
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}


